/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export type HeaderNavGenre = 'destinations' | 'journeys' | 'stays' | 'experiences';
export type HeaderNavLocation = 'header' | 'sidebar';

export interface ClickHeaderNavParams {
  item_name: string;
  location: HeaderNavLocation;
}

/**
 * 発火タイミング：ヘッダーまたはサイドバーのジャンル導線がクリックされた時
 */
export const sendGAWabunkaClickHeaderNavEvent = (genre: HeaderNavGenre, itemName: string, location: HeaderNavLocation) => {
  sendWabunkaGAEvent(`click_header_nav_${genre}`, { item_name: itemName, location });
};
